import CloseIcon from "@mui/icons-material/Close";
import {
  Avatar,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

interface Props {
  carrierTeammatesOpened: boolean;
  closeCarrierTeammates: VoidFunction;
  teammates: TeammateQuoteInfo[];
}

export function QuotesTeammates(props: Props) {
  const { carrierTeammatesOpened, closeCarrierTeammates, teammates } = props;
  return (
    <Dialog
      open={carrierTeammatesOpened}
      onClose={closeCarrierTeammates}
      maxWidth="lg"
    >
      <DialogTitle component="div">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5">Users Who Have Quoted This Load</Typography>
          <IconButton onClick={closeCarrierTeammates} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          {teammates.map((teammate) => (
            <Stack
              key={`${teammate.first_name}-${teammate.last_name}`}
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <Avatar>{teammate.first_name?.[0] || "?"}</Avatar>
              <Typography variant="h6">
                {teammate.first_name} {teammate.last_name}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
